module.exports = {
    redirectUri: "https://reactApp/oauth2/redirect",
    apiBaseUrl: "http://localhost:8080"
};